<template>
  <h-fs-dialog
    :value="show"
    bottom
  >
    <v-card tile light>
      <h-turn-toolbar
        :title="__(openingTurn ? 'openTurn' : 'closeTurn')"
        @close="close"
        @done="done"
      />
      <v-divider />
      <v-card-text class="pa-0">
        <h-payment-methods />
        <h-monies />
      </v-card-text>
      <h-turn-calculator />
      <h-turn-total />
    </v-card>
    <h-confirm
      v-model="zeroConfirm"
      :title="__('areYouSure')"
      :text="__(openingTurn ? 'openZeroTurn' : 'closeZeroTurn')"
      @yes="done(false)"
      @no="zeroConfirm = false"
    />
  </h-fs-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  import I18n from '@/Mixins/I18n'
  import Lockable from '@/Mixins/Lockable'
  import ManagesTurns from '@/Mixins/ManagesTurns'
  import HFsDialog from '@/Components/FullScreenDialog'
  import HConfirm from '@/Components/Messages/Confirm'
  import HTurnToolbar from './Toolbar'
  import HPaymentMethods from './PaymentMethods'
  import HMonies from './Monies'
  import HTurnCalculator from './Calculator'
  import HTurnTotal from './Total'

  export default {
    mixins: [
      I18n,
      Lockable,
      ManagesTurns,
    ],

    components: {
      HFsDialog,
      HConfirm,
      HTurnToolbar,
      HPaymentMethods,
      HMonies,
      HTurnCalculator,
      HTurnTotal,
    },

    data: () => ({
      zeroConfirm: false,
    }),

    computed: {
      ...mapState('cashControl/form', [
        'show',
        'tills',
        'total',
      ]),
    },

    methods: {
      submitTurn () {
        return this.openingTurn
          ? this.openTurn(this.tills.cash)
          : this.closeTurn(this.tills)
      },
      done (checkAmount = true) {
        if (this.locked) {
          return
        }
        this.lock()
        if (checkAmount && this.total.equalTo(0)) {
          this.zeroConfirm = true
          return
        }
        this.submitTurn().finally(() => this.close())
      },
      close () {
        this.zeroConfirm = false
        this.$store.commit('cashControl/form/hide')
      },
    },
  }
</script>
